import { render } from "./StoryEditDropdown.vue?vue&type=template&id=7ef4d062&ts=true"
import script from "./StoryEditDropdown.vue?vue&type=script&lang=ts"
export * from "./StoryEditDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__